import Component, { forceArray } from 'navigation/component/Component';
import ImageZoom from 'sections/editorial/ImageZoom';
import { bindMethod } from 'helpers/bind';
class ArticleGallery extends Component {
    bindEvents(add = true) {
        const method = bindMethod(add);
        forceArray(this.refs.items).forEach((item, i) => {
            item[method]('click', () => this.modules.zoom.open(i));
        });
    }
    getModulesMap() {
        return {
            zoom: ['.image-zoom', ImageZoom]
        };
    }
}
export default ArticleGallery;
